import select2 from "select2"
import "select2/dist/css/select2.css"
import "select2-bootstrap4-theme/dist/select2-bootstrap4.css"
select2(window, $)

import { Stimulus, Controller } from "#/application/js/stimulus"

const renderVehicleOption = function(vehicle) {
  if (vehicle.id)
    return $(`<span class="vehicle-option-${vehicle.id}">${vehicle.text}</span>`)
  else
    return vehicle.text
}

const showVehicle = function() {
  const vehicle = document.querySelector("#request_vehicle_id option:checked")
  if (!vehicle || vehicle.value == "")
    return

  const frame = document.getElementById("vehicle-photo")
  if (frame) frame.src = `/vehicles/${vehicle.value}/preview`
}

Stimulus.register("select2", class extends Controller {
  static targets = ["default", "vehicle", "admin"]

  defaultTargetConnected(el) {
    $(el).select2({ theme: "bootstrap4" })
  }

  vehicleTargetConnected(el) {
    $(el).select2({
      theme: "bootstrap4",
      templateResult: renderVehicleOption,
      templateSelection: renderVehicleOption
    })

    showVehicle()
  }

  adminTargetConnected(el) {
    $(el).select2({
      theme: "bootstrap4",
      width: "50%",
      placeholder: "Search for a user...",
      minimumInputLength: 3,
      ajax: {
        url: "/admin/admins",
        dataType: "json",
        delay: 250
      }
    })
  }
})

$(document).on("select2:open", "select", function() {
  document.querySelector("input.select2-search__field").focus()
})

$(document).on("select2:select", "#request_vehicle_id", showVehicle)
